import {
  Autoplay,
  Swiper,
  Navigation,
  // Scrollbar,
} from 'swiper';

// Navigation // Keyboard // Scrollbar
Swiper.use([Autoplay, Navigation]);

const navigation = (target) => {
  const swiperClass = {
    nextEl: `.${target}-swiper-controls__next`,
    prevEl: `.${target}-swiper-controls__prev`,
  };

  return swiperClass;
};

$(window).on('load', function () {
  swipers();
});

const swipers = () => {
  challengeSwiper();
  eventSwiper();
  gallerySwiper();
  teamSwiper();
  partnerSwiper();
};
const challengeSwiper = () => {
  return new Swiper('.challenge-swiper', {
    spaceBetween: 30,
    slidesPerView: 2,
    breakpoints: {
      1200: {
        slidesPerView: 2,
      },
      993: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 1.05,
        spaceBetween: 15,
      },
      0: {
        slidesPerView: 1.05,
        spaceBetween: 15,
      },
    },
    navigation: navigation('challenge'),
  });
};

const eventSwiper = () => {
  return new Swiper('.event-swiper', {
    spaceBetween: 30,
    slidesPerView: 2,
    breakpoints: {
      1200: {
        slidesPerView: 2,
      },
      993: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 1.05,
        spaceBetween: 15,
      },
      0: {
        slidesPerView: 1.05,
        spaceBetween: 15,
      },
    },
    navigation: navigation('event'),
  });
};

const gallerySwiper = () => {
  const swiper = new Swiper('.gallery-swiper', {
    loop: true,
    slidesPerView: 'auto',
    spaceBetween: 30,
    watchSlidesProgress: true,
    navigation: navigation('gallery'),
  });

  return swiper;
};

const teamSwiper = () => {
  return new Swiper('.team-swiper', {
    spaceBetween: 30,
    slidesPerView: 3,
    breakpoints: {
      1200: {
        slidesPerView: 3,
      },
      993: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 1.1,
        spaceBetween: 15,
      },
      0: {
        slidesPerView: 1.1,
        spaceBetween: 15,
      },
    },
    navigation: navigation('team'),
  });
};

const partnerSwiper = () => {
  return new Swiper('.partner-swiper', {
    spaceBetween: 30,
    slidesPerView: 6,
    autoplay: true,
    breakpoints: {
      1400: {
        slidesPerView: 6,
      },
      1200: {
        slidesPerView: 5,
      },
      993: {
        slidesPerView: 4,
      },
      767: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      0: {
        slidesPerView: 1.8,
        spaceBetween: 15,
      },
    },
  });
};
